import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { betApi as betHistoryApi } from '@/store/api/betReportApi';

interface CurrentBetCountState {
  totalItems: number;
  normalPendingCount: number;
  parlayPendingCount: number;
  totalPendingCount: number;
  isFloatingMyBetsVisible: boolean;
  isMyBetsModalOpen: boolean;
}

const initialState: CurrentBetCountState = {
  totalItems: 0,
  normalPendingCount: 0,
  parlayPendingCount: 0,
  totalPendingCount: 0,
  isFloatingMyBetsVisible: false,
  isMyBetsModalOpen: false,
};

export const currentBetCountSlice = createSlice({
  name: 'currentBetCount',
  initialState,
  reducers: {
    clearBetCount: (state) => {
      state.totalItems = 0;
      state.normalPendingCount = 0;
      state.parlayPendingCount = 0;
      state.totalPendingCount = 0;
    },
    setFloatingMyBetsVisible: (state, action: PayloadAction<boolean>) => {
      state.isFloatingMyBetsVisible = action.payload;
    },
    openMyBetsModal: (state) => {
      state.isMyBetsModalOpen = true;
    },
    closeMyBetsModal: (state) => {
      state.isMyBetsModalOpen = false;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      betHistoryApi.endpoints.getPendingBetsCount.matchFulfilled,
      (state, { payload }) => {
        state.normalPendingCount = payload.normalPendingCount ?? 0;
        state.parlayPendingCount = payload.parlayPendingCount ?? 0;
        state.totalPendingCount = payload.totalPendingCount ?? 0;
        state.totalItems = payload.totalPendingCount ?? 0;
      }
    );
  },
});

export const { setFloatingMyBetsVisible, openMyBetsModal, closeMyBetsModal, clearBetCount } =
  currentBetCountSlice.actions;

export default currentBetCountSlice.reducer;
